import { useState } from "react";

import { AddMoreButton, SectionTitle } from "@components";
import { NewPostingRecordPosting } from "./NewPostingRecordPosting";
import { PostingRecordPosting } from "./PostingRecordPosting";

import { PostingRecordPostingType } from "@type/HRM/postings";
import { useBaseData } from "@hooks/useBaseData";

import { BASE_DATA } from "@constants/base-data";
import Accordion from "@components/Accordion";
import { Text } from "@pentabd/ui";

interface PostingRecordPostingPropsType {
  postingRecordPostingsInfo: PostingRecordPostingType[];
  changePostingRecordPostingsInfo: (data: PostingRecordPostingType) => void;
  removePostingRecordPostingInfo: (postingRecordPostingId: number) => void;
  getPostingRequestOngoing: boolean;
  updatePostingRecordPostingRequestOngoing: boolean;
  deletePostingRecordPostingRequestOngoing: boolean;
  isProfileDisabled: boolean;
}

export const PostingRecordPostings = ({
  postingRecordPostingsInfo,
  changePostingRecordPostingsInfo,
  removePostingRecordPostingInfo,
  getPostingRequestOngoing,
  updatePostingRecordPostingRequestOngoing,
  deletePostingRecordPostingRequestOngoing,
  isProfileDisabled,
}: PostingRecordPostingPropsType) => {
  const [newPostingRecordPostingFormShow, setNewPostingRecordPostingFormShow] =
    useState(false);
  const handleNewPostingRecordPostingFormShow = (isShow: boolean) =>
    setNewPostingRecordPostingFormShow(isShow);

  const { data: grades } = useBaseData(BASE_DATA.GRADES);

  return (
    <div className="d-flex flex-column gap-8">
      <SectionTitle
        label="EMPLOYEE.POSTINGS_INFO.FORM.POSTING_RECORDS_INFO.HEADING"
        size="lg"
        noBorder
      />

      {postingRecordPostingsInfo?.map((postingRecordPosting) => (
        <Accordion
          key={postingRecordPosting.id}
          accordionBody={
            <PostingRecordPosting
              postingRecordPostingInfo={postingRecordPosting}
              changePostingRecordPostingsInfo={changePostingRecordPostingsInfo}
              removePostingRecordPostingInfo={removePostingRecordPostingInfo}
              getPostingRequestOngoing={getPostingRequestOngoing}
              updatePostingRecordPostingRequestOngoing={
                updatePostingRecordPostingRequestOngoing
              }
              deletePostingRecordPostingRequestOngoing={
                deletePostingRecordPostingRequestOngoing
              }
              grades={grades}
              isProfileDisabled={isProfileDisabled}
            />
          }
          className="pointer p-8 bg-primary-25 rounded-4 border border-primary"
          accordionHeader={
            <Text size="lg" weight="semibold" color="dark">
              {postingRecordPosting.post}
            </Text>
          }
        />
      ))}

      {newPostingRecordPostingFormShow ? (
        <NewPostingRecordPosting
          key="NEW_POSTING_RECORD"
          handleNewPostingRecordPostingFormShow={
            handleNewPostingRecordPostingFormShow
          }
          changePostingRecordPostingsInfo={changePostingRecordPostingsInfo}
          updatePostingRecordPostingRequestOngoing={
            updatePostingRecordPostingRequestOngoing
          }
          grades={grades}
          isProfileDisabled={isProfileDisabled}
        />
      ) : (
        <AddMoreButton
          label="EMPLOYEE.POSTINGS_INFO.FORM.POSTING_RECORDS_INFO.ADD_MORE_BUTTON"
          clickAction={() => handleNewPostingRecordPostingFormShow(true)}
          disabled={isProfileDisabled}
        />
      )}
    </div>
  );
};

export default PostingRecordPostings;
